import Honeybadger from "@honeybadger-io/js"
import { loadStripe } from "@stripe/stripe-js"

import { safeHoneybadgerNotify } from "./honeybadgerNoiseFilter"

/**
 * Safely loads Stripe.js with error handling
 * @param {string} stripeKey - The Stripe publishable key
 * @param {object} options - Additional options for loadStripe
 * @returns {Promise} A promise that resolves to the Stripe instance or null on error
 */
export function safeLoadStripe(stripeKey, options = {}) {
  if (typeof window === "undefined") {
    return null
  }

  if (!stripeKey) {
    const error = new Error("Stripe key is not defined")
    console.error("Failed to load Stripe.js: Stripe key is not defined")
    safeHoneybadgerNotify(Honeybadger, error, {
      context: {
        stripeKey: stripeKey ? "defined" : "undefined",
        windowAppStripeKey: window.App?.stripe_key ? "defined" : "undefined"
      }
    })
    return Promise.resolve(null)
  }

  return loadStripe(stripeKey, options).catch((error) => {
    console.error("Failed to load Stripe.js:", error)
    safeHoneybadgerNotify(Honeybadger, error, {
      context: {
        stripeKey: stripeKey ? "defined" : "undefined",
        errorMessage: error.message,
        errorStack: error.stack
      }
    })
    // Return null instead of throwing to prevent unhandled promise rejection
    return null
  })
}
